import { TInsertAllAnswersRequest } from "../services/types";

export {};

export type TExercise = {};

export type TExercisesCategory = {};
export const initialQuestion: TInsertAllAnswersRequest = {
  Id: "0",
  QuestionnaireId: "",
  QuestionsId: "",
  UsersId: "",
  Answer: "",
};
export const rtlLanguageCodes = [
  "ar",
  "ar-ae",
  "ar-bh",
  "ar-dz",
  "ar-eg",
  "ar-iq",
  "ar-jo",
  "ar-kw",
  "ar-lb",
  "ar-ly",
  "ar-ma",
  "ar-om",
  "ar-qa",
  "ar-sa",
  "ar-sd",
  "ar-sy",
  "ar-tn",
  "ar-ye",
  "he",
  "fa",
  "ur",
  "ps",
  "sd",
  "ug",
  "dv",
  "ku-arab",
  "yi-001",
];

export //in future need to replace them with types from db
enum DataTypes {
  Options = 1,
  Text = 2,
  Number = 3,
  Date = 4,
  AutoAdvance = 5,
  Voice = 6,
  File = 7,
  AI = 8,
  Signature = 10,
}
